import { USER_FEATURES_KEYS } from 'consts';

import { useGetOrganisationFeatureAccess } from './useGetOrganisationFeatureAccess';

export const useTechnicalUsersFeature = () =>
  useGetOrganisationFeatureAccess(USER_FEATURES_KEYS.technicalUsers);
